import type { TFunction } from 'i18next';

import { LAYER_TYPES } from '../components/project-settings/types';

/** User-facing name of a layer type ("Pedestrian" → "Pedestrian zone"); falls back to the key. */
export const layerTypeLabel = (t: TFunction, type: string): string =>
  t(`projects.newProject.dxf.layerType.${type}`, { defaultValue: type });

/** Layer types offered in the type dropdowns. Pedestrian zone only with the IDLC-1129 flag, or when
 *  the layer already has it (so it stays visible as the current choice). */
export const layerTypeKeys = (includePedestrian: boolean, current?: string): Array<keyof typeof LAYER_TYPES> =>
  (Object.keys(LAYER_TYPES) as Array<keyof typeof LAYER_TYPES>).filter(
    (type) => type !== 'Pedestrian' || includePedestrian || current === 'Pedestrian',
  );
